import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// Vuetify
import 'vuetify/styles'; // Vuetify CSS
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

// PrimeVue
import PrimeVue from "primevue/config"
// import Button from 'primevue/button';

// Theme (NEW in PrimeVue v4)
import Aura from "@primevue/themes/aura"

// Components
import Panel from 'primevue/panel'
import Button from 'primevue/button'
import Avatar from 'primevue/avatar'
import Menu from 'primevue/menu'
import Checkbox from 'primevue/checkbox';
import Password from 'primevue/password';

// Icons
import "primeicons/primeicons.css"

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
      },
    },
  },
});

createApp(App)
  .use(createPinia()) // register Pinia
  .use(router) 
  .use(vuetify) 
  .use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: false // disable automatic dark mode
      }
    }
  })
  .component('Panel', Panel)
  .component('Menu', Menu)
  .component('Avatar', Avatar)
  .component('Button',Button)
  .component('Checkbox',Checkbox)
  .component('Password', Password)
  .mount('#app')        // mount the app

